import { UwtType } from 'modules/types/LeasingCalculatorCodes';
import { OptionType } from 'modules/types/LocationCodes';

export const hasOnlyEmptyValues = (arrayOfElements: OptionType[]) =>
  arrayOfElements.every((elem) => !elem.label || elem.label === '');

export const isEmptyUwtObject = (uwtObject: UwtType) =>
  (uwtObject.id === 0 || !uwtObject.id) &&
  (uwtObject.name === '' || !uwtObject.name);
